<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <v-row class="ma-0 mt-5 mb-4">
        <v-col class="pa-0 my-4">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #000000;">{{ "Conversiones activas" }}</div>
          <div style="font-family: 'montserrat-regular'; font-size: 14px;"> {{ "Aqui encontraras las conversiones activas de que estan pendientes de realizarse." }}</div>
        </v-col>
      </v-row>
      <v-row justify="start" align="center" class="d-flex pl-0 ma-0 mb-4">
        <v-col class="d-flex pl-0 py-0">
          <div style="width: 286px;">
            <v-autocomplete
              label="Selecciona un usuario"
              :items="users"
              hide-details
              style="font-family: 'montserrat-medium'; border-radius: 20px;"
              outlined
              clearable
              class="mr-2"
              item-value="sCustomerEnterpriseId"
              item-text="sName"
              @change="getActiveConversionsHistory()"
              v-model="selectedUser"
            ></v-autocomplete>
          </div>
        </v-col>
        <v-col class="d-flex justify-end pa-0 my-4">
          <v-btn color="#000000" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="dataXLSX()">
            <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
            {{ "Descargar" }}
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table class="d-none d-sm-block" hide-default-header :items="items">
        <template v-slot:header="{ props }">
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left">{{ "Id" }}</th>     
              <th class="header__title center">{{ "Usuario" }}</th>                                                                                                                                                                                    
              <th class="header__title center">{{ "Fecha de creación" }}</th>                                                                                                                                                                       
              <th class="header__title center">{{ "Tipo de transaccion" }}</th>                                                                                                                                                                                                                      
              <th class="header__title center">{{ "Fecha de vencimiento" }}</th>
              <th class="header__title center">{{ "Días faltantes" }}</th>           
              <th class="header__title center">{{ "Tipo de cambio" }}</th>                                                                                                                                                                                                               
              <th class="header__title center">{{ "Monto origen restante" }}</th>
              <th class="header__title center">{{ "Monto origen total" }}</th>
              <th class="header__title right">{{ "Monto destino" }}</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item">{{ item.sTransactionId }}</td>
              <td class="table__item">{{ item.CustomerEnterprises }}</td>
              <td class="table__item">{{ formatDate(item.created_at) }}</td>
              <td class="table__item">
                <v-chip v-if="item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'" class="ma-2" color="red" outlined style="background-color: #FDF0F5 !important; border-width: 1.5px;">
                  {{ "Forward" }}
                </v-chip>
                <v-chip v-else-if="item.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" class="ma-2" color="#FB0075" outlined style="background-color: #FDEBEB !important; border-width: 1.5px;">
                  {{ "Window spot" }}
                </v-chip>
              </td>
              <td class="table__item">{{ item.dForwardTransactionDate ? formatDate(item.dForwardTransactionDate) : "-" }}</td>
              <td class="table__item">{{ item.diasFaltantes + " days" }}</td>
              <td class="table__item">{{  "$ " + formatMoney(item.dExchangeRate) + " MXN" }}</td>
              <td class="table__item">{{ "$ " + formatMoney(item.dAmountRemaining) + " " + (item.sCurrency ? item.sCurrency : "USD") }}</td>
              <td class="table__item">{{ "$ " + formatMoney(item.dAmount) + " " + (item.sCurrency ? item.sCurrency : "USD") }}</td>
              <td class="table__item">{{ "$ " + formatMoney(item.dDesAmount) + " " + (item.sDestCurrency ? item.sDestCurrency : "MXN") }}</td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-data-table class="d-sm-none d-block" hide-default-header :items="items">
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
              <td class="table__item__mobile">
                <div>{{ "Id" }}</div>
                <div>{{ item.iTrackingId }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Usuario" }}</div>
                <div>{{ item.CustomerEnterprises }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Fecha de creación" }}</div>
                <div>{{ formatDate(item.created_at) }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Tipo de transaccion" }}</div>
                <div>
                  <v-chip v-if="item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'" class="ma-2" color="red" outlined>
                    {{ "Forward" }}
                  </v-chip>
                  <v-chip v-else-if="item.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" class="ma-2" color="#FB0075" outlined style="background-color: #FDEBEB !important; border-width: 1.5px;">
                    {{ "Spot window" }}
                  </v-chip>
                </div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Fecha de vencimiento" }}</div>
                <div>{{ item.dForwardTransactionDate ? formatDate(item.dForwardTransactionDate) : "-" }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Días faltantes" }}</div>
                <div>{{ item.diasFaltantes + " days" }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Tipo de cambio" }}</div>
                <div>{{  "$ " + formatMoney(item.dExchangeRate) + " MXN" }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Monto origen restante" }}</div>
                <div>{{ "$ " + formatMoney(item.dAmountRemaining) + " " + (item.sCurrency ? item.sCurrency : "USD") }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Monto origen total" }}</div>
                <div>{{ "$ " + formatMoney(item.dAmount) + " " + (item.sCurrency ? item.sCurrency : "USD") }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Monto destino" }}</div>
                <div>{{ "$ " + formatMoney(item.dDesAmount) + " " + (item.sDestCurrency ? item.sDestCurrency : "MXN") }}</div>
              </td>
              <v-divider></v-divider>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

export default {
  name: "DashboardView",
  data() {
    return {
      nameXLSX: "HistorialConversiones.xlsx",
      users: [],
      selectedUser: "",
      isLoading: false,
      items: [],
    };
  },
  methods: {
    getUsers() {
      this.isLoading = true;
      DB.get(`${URI}/api/v1/en/administrator/users`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      }).then((response) => {
        this.users = response.data.results
        this.isLoading = false;
      }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    getActiveConversionsHistory() {
      this.isLoading = true;
      const payload = {
        sEnterpriseId: this.selectedUser,
      };

      DB.post(`${URI}/api/v1/en/administrator/forwardsActive`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        this.items = response.data.forwards
        this.isLoading = false;
      }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    formatMoney: function (value) {
      let multiplied = value * 100;
      let rounded = Math.round(multiplied);
      let formattedNumber = rounded / 100;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(formattedNumber);
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM D, YYYY");
      return formattedDate;
    },
    dataXLSX() {
      try {
        let data = this.items.map((item) => {
          return {
            Id: item.iTrackingId ? item.iTrackingId : "",
            "Fecha de creación": item.created_at ? this.formatDate(item.created_at) : "",
            "Type Transaction": item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3' ? 'Forward' : (item.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a' ? 'Forex' : "N/A"),
            "Total amount": item.dAmount ? `$ ${this.formatMoney(item.dAmount)} ${item.sCurrency || 'USD'}` : "",
            "Dest amount": item.dDesAmount ? `$ ${this.formatMoney(item.dDesAmount)} ${item.sDestCurrency || 'MXN'}` : "",
            "Exchange rate": item.dExchangeRate ? item.dExchangeRate : "",
            Invoice: item.invoice ? item.invoice : "",
            "Purchase Date": item.purchaseDate ? item.purchaseDate : "",
            "Currency profit (%)": item.percentProfit ? parseFloat(item.percentProfit) : "",
            "Currency gain (USD)": item.dollarProfit ? parseFloat(item.dollarProfit) : "",
          };
        });
        const worksheet = XLSX.utils.json_to_sheet(data);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Hoja1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        saveAs(blob, this.nameXLSX);
        this.success = true;
        this.msgSuccess = "Descargando documento";
      } catch (error) {
        this.error = true;
        this.codeError = "CSV_NO_DATA";
      }
    },
  },
  beforeMount() {
    this.getUsers();
    this.getActiveConversionsHistory();
  },
};
</script>

<style>
</style>
